import { render, staticRenderFns } from "./TransportInterManage.vue?vue&type=template&id=1f9ab8a8&"
import script from "./TransportInterManage.vue?vue&type=script&lang=js&"
export * from "./TransportInterManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports